"use client";

import { Box } from "@mui/material";
import { keyframes } from "@mui/material/styles";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const slices = [
  { d: "M12 12 L12 4.2 A7.8 7.8 0 0 1 19.8 12 Z", fill: "#C45C6A" },
  { d: "M12 12 L19.8 12 A7.8 7.8 0 0 1 12 19.8 Z", fill: "#C9892D" },
  { d: "M12 12 L12 19.8 A7.8 7.8 0 0 1 4.2 12 Z", fill: "#5E7D68" },
  { d: "M12 12 L4.2 12 A7.8 7.8 0 0 1 12 4.2 Z", fill: "#2C2420" },
];

export default function AnimatedWheelIcon({ size = 20 }: { size?: number }) {
  return (
    <Box
      component="span"
      aria-hidden
      sx={{
        display: "inline-flex",
        width: size,
        height: size,
        lineHeight: 0,
        flexShrink: 0,
        "& .wheel-spin": {
          transformBox: "fill-box",
          transformOrigin: "center",
          animation: `${spin} 3.2s linear infinite`,
        },
        "@media (prefers-reduced-motion: reduce)": {
          "& .wheel-spin": { animation: "none" },
        },
      }}
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <g className="wheel-spin">
          {slices.map((slice) => (
            <path key={slice.fill} d={slice.d} fill={slice.fill} />
          ))}
          <circle cx="12" cy="12" r="8.6" fill="none" stroke="#E7A66B" strokeWidth="1.5" />
          <circle cx="12" cy="12" r="2.1" fill="#fff" />
          <circle cx="12" cy="12" r="1.1" fill="#212121" />
        </g>
      </svg>
    </Box>
  );
}
